import { createAsyncThunk } from '@reduxjs/toolkit';
import { uploadPhoto } from 'integration/api/photo';
import { PhotoActions } from 'applicaiton/constants/actions';
import { AxiosError } from 'axios';

/**
 * Asynchronously uploads a new photo.
 *
 * @param data - The FormData containing the photo to upload.
 * @returns A Promise that resolves with the uploaded photo data, or rejects with an error message.
 */
export const uploadNewPhoto = createAsyncThunk(
  PhotoActions.uploadPhoto,
  async (data: FormData, { rejectWithValue }) => {
    try {
      const response = await uploadPhoto(data);
      return response.data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
